export default __webpack_public_path__ + "static/Isometric-grid-light-80bbeb39e65f09958447b40b36417e12.png";